import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Layout, Row, Col } from 'antd';
import { Modal as ModalMobile } from 'antd-mobile';
import * as SignalR from '@aspnet/signalr';
import { Markup } from 'interweave';
import IdleTimer from 'react-idle-timer';
import HomeCarouselThemeTwo from '../../modules/ThemeTwo/HomeCarouselThemeTwo';
import HomeContentThemeTwo from '../../modules/ThemeTwo/HomeContentThemeTwo';
import HomeFooterThemeTwo from '../../modules/ThemeTwo/HomeFooterThemeTwo';

const { Content } = Layout;
const REACT_APP_SIGNALR_URL = `${process.env.REACT_APP_STAYMENU_API_URL}/stayMenuHub`;
const confirmAlert = ModalMobile.alert;

@inject(
    'VersionStore',
    'templateStore',
    'CmsLanguageStore',
    'CmsMenuStore',
    'popupStore',
    'webSettingStore',
    'loginStore',
    'authStore',
    'amenityStore',
    'fnbStore',
    'laundryStore',
    'shoppingStore',
    'TransactionStore',
    'CmsSidebarStore'
)
@observer
class HomeThemeTwo extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showSideBar: true
        }
    }

    componentDidMount() {
        const roomNo = this.props.loginStore.getRoomNo();
        if (!roomNo) {
            this.props.history.push('/login');
        }

        this.props.loginStore.authenticateGuest().then(response => {
            if (!response) {
                this.props.history.push('/login');
            }
        });

        this.props.CmsMenuStore.getActives();
        this.props.CmsSidebarStore.getAllByLanguage();

        this.props.CmsLanguageStore.getActives().then(() => {
            this.props.templateStore.getActive().then(() => {
                this.props.webSettingStore.getData().then(() => {
                    const { activeTemplate } = this.props.templateStore;
                    const { data: webSettting } = this.props.webSettingStore;

                    if (webSettting) {
                        this.props.popupStore.getByModuleName('HOME').then(resp => {
                            if (resp) {
                                if (resp.title) {
                                    confirmAlert(
                                        <div style={{
                                            fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                            color: activeTemplate.templateSetting.label.color,
                                            fontSize: activeTemplate.templateSetting.label.fontSize,
                                            lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                                        }}>
                                            <span>{resp.title}</span>
                                        </div>,
                                        <div style={{
                                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                            color: activeTemplate.templateSetting.text.color,
                                            fontSize: activeTemplate.templateSetting.text.fontSize,
                                            lineHeight: `${activeTemplate.templateSetting.text.fontSize + 8}px`
                                        }}>
                                            <Markup content={resp.description} />
                                        </div>,
                                        [
                                            {
                                                text: <span style={{
                                                    fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                    color: activeTemplate.templateSetting.label.color,
                                                    fontSize: activeTemplate.templateSetting.label.fontSize,
                                                    lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                                                }}>OK</span>
                                            }
                                        ]);
                                }
                            }
                        });

                    }
                });
            });
        });

        let connection = new SignalR.HubConnectionBuilder().withUrl(REACT_APP_SIGNALR_URL).build();
        connection.start().catch(function (err) { return console.error(err.toString()); });
        connection.on(`SignalR_SyncData`, () => { window.location.reload(true); });
    }

    componentWillUnmount() {
    }

    checkSmVersion = () => {
        this.props.VersionStore.check().then(resp => {
            if (!resp) {
                const { activeTemplate } = this.props.templateStore;
                const { data: webSettting } = this.props.webSettingStore;

                confirmAlert(
                    <div
                        style={{
                            fontFamily: activeTemplate.templateSetting.label.fontFamily,
                            color: activeTemplate.templateSetting.label.color,
                            fontSize: activeTemplate.templateSetting.label.fontSize,
                            lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                        }}>
                        <span>Info</span>
                    </div>,
                    <div
                        style={{
                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                            color: activeTemplate.templateSetting.text.color, fontSize: activeTemplate.templateSetting.text.fontSize,
                            lineHeight: `${activeTemplate.templateSetting.text.fontSize + 6}px`, textAlign: 'center'
                        }}>
                        <span>New version has been released. Please refresh the page.</span>
                    </div>, [
                    {
                        text:
                            <span
                                style={{
                                    fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                    color: activeTemplate.templateSetting.label.color,
                                    fontSize: activeTemplate.templateSetting.label.fontSize,
                                    lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                                }}
                            >
                                {webSettting.okText}
                            </span>,
                        onPress: () => {
                            window.location.reload(true);
                        }
                    }
                ]);
            }
        });
    }

    sideBarClicked = () => {
        this.setState({
            showSideBar: !this.state.showSideBar
        })
    }

    aboutHotelClick = () => {
        this.props.history.push('./about-hotel');
    }

    compendiumClick = (id) => {
        this.props.history.push(`./compendium/${id}`);
    }

    logoutClick = () => {
        // RESET Storage
        this.props.authStore.removeGuestInformationInStorage();

        // RESET Store Value
        this.props.amenityStore.resetData();
        this.props.fnbStore.resetData();
        this.props.laundryStore.resetData();
        this.props.shoppingStore.resetData();
        this.props.TransactionStore.resetData();

        this.props.history.push(`./login`);
    }

    render() {
        const history = this.props.history;
        const { activeTemplate } = this.props.templateStore;
        const { data: webSetting } = this.props.webSettingStore;
        const { showSideBar } = this.state;
        const { sidebars } = this.props.CmsSidebarStore;

        return (
            <>
                {
                    activeTemplate
                        ?
                        <>
                            {
                                webSetting
                                    ?
                                    <>
                                        <Layout className='stm-layout-master'>
                                            <IdleTimer ref={ref => { this.idleTimer = ref }} timeout={1000 * 5} onIdle={this.checkSmVersion} debounce={250} />
                                            <Content className=''>
                                                <Row>
                                                    <Col span={24} className='stm-height-50-vh'>
                                                        <HomeCarouselThemeTwo history={history} />
                                                        <div className='stm-home-theme-two-setting'>
                                                            <img
                                                                src={require('../../assets/TemplateTwo/Images/Icons/Setting.svg')}
                                                                alt='Logo'
                                                                className=''
                                                                onClick={this.sideBarClicked}
                                                            />
                                                        </div>
                                                        <HomeContentThemeTwo history={history} />
                                                        <HomeFooterThemeTwo history={history} />
                                                    </Col>
                                                </Row>
                                                <Row
                                                    className='stm-home-theme-sidebar-container'
                                                    hidden={showSideBar}
                                                    style={{
                                                        minHeight: document.documentElement.clientHeight,
                                                        background: activeTemplate.templateSetting.header.backgroundColor,
                                                        fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                        color: activeTemplate.templateSetting.header.color,
                                                        fontSize: activeTemplate.templateSetting.label.fontSize,
                                                        lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                                                    }}
                                                >
                                                    <Col>
                                                        <Row>
                                                            <Col span={24} className='stm-home-theme-sidebar-item' onClick={this.aboutHotelClick}>
                                                                <span>{webSetting.aboutHotelText}</span>
                                                            </Col>
                                                        </Row>
                                                        {/* Compendium */}
                                                        <>
                                                            {
                                                                sidebars
                                                                    ?
                                                                    <>
                                                                        {
                                                                            sidebars.map(sidebar => {
                                                                                return (
                                                                                    <Row>
                                                                                        <Col span={24} className='stm-home-theme-sidebar-item' onClick={() => this.compendiumClick(sidebar.id)}>
                                                                                            <span>{sidebar.title}</span>
                                                                                        </Col>
                                                                                    </Row>
                                                                                )
                                                                            })
                                                                        }
                                                                    </>
                                                                    :
                                                                    null
                                                            }
                                                        </>
                                                        <Row>
                                                            <Col span={24} className='stm-home-theme-sidebar-item' onClick={this.logoutClick}>
                                                                <span>{webSetting.logoutText}</span>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </Content>
                                        </Layout>
                                    </>
                                    :
                                    null
                            }
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default (HomeThemeTwo)